function Details() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.66536H3.33333V13.332H12.6667V5.33203H10V2.66536ZM2 1.99336C2 1.62803 2.298 1.33203 2.666 1.33203H10.6667L14 4.66536V13.994C14.0006 14.0816 13.984 14.1684 13.951 14.2495C13.9181 14.3306 13.8695 14.4045 13.808 14.4668C13.7466 14.5291 13.6734 14.5788 13.5928 14.6128C13.5121 14.6469 13.4255 14.6648 13.338 14.6654H2.662C2.48692 14.6641 2.31934 14.5941 2.19548 14.4704C2.07161 14.3466 2.0014 14.1791 2 14.004V1.99336ZM7.33333 7.33203H8.66667V11.332H7.33333V7.33203ZM7.33333 4.66536H8.66667V5.9987H7.33333V4.66536Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Details;
